import { render, staticRenderFns } from "./ModalV3.vue?vue&type=template&id=66b7b803&scoped=true"
import script from "./ModalV3.vue?vue&type=script&lang=ts"
export * from "./ModalV3.vue?vue&type=script&lang=ts"
import style0 from "./ModalV3.vue?vue&type=style&index=0&id=66b7b803&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b7b803",
  null
  
)

export default component.exports